import React, {Component} from 'react'
import PropTypes from 'prop-types'
import config from 'config'
import scriptLoader from 'react-async-script-loader'

class Rate extends Component {
  static propTypes = {
    creditScoreTier: PropTypes.number,
    rateType: PropTypes.string.isRequired,
    vertical: PropTypes.string,
    lenderSlug: PropTypes.string,
    term: PropTypes.number,
    variable: PropTypes.bool,
    name: PropTypes.string,
    decimals: PropTypes.number,
    append: PropTypes.string,
    prepend: PropTypes.string
  }

  static defaultProps = {
    creditScoreTier: null,
    decimals: 2,
    append: '%',
    prepend: ''
  }

  render() {
    const {
      creditScoreTier, rateType, vertical, lenderSlug, term, variable, name,
      decimals, append, prepend, isScriptLoaded, isScriptLoadSucceed,
      className
    } = this.props

    if (isScriptLoaded && isScriptLoadSucceed) {
      // eslint-disable-next-line no-undef
      const rate = ratesLibrary.getRateValue({creditScoreTier, rateType, vertical, lenderSlug, term, variable, name}, {decimals, append, prepend})

      return <span className={className}>{rate}</span>
    }

    return null
  }
}

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
const RateScript = /*#__PURE__*/ scriptLoader(config.ratesLibraryUrl)(Rate)

export {Rate} // For unit test

export {RateScript}
